import Immutable from 'immutable';
import {ReduceStore} from 'flux/utils';
import NotificationCountActionTypes from '../actions/NotificationCountActionTypes';
import NotificationCountDispatcher from '../actions/NotificationCountDispatcher';
import GlobalSharedTools from '../../../lib/GlobalSharedTools';

class NotificationCountStore extends ReduceStore {
  constructor() {
    super(NotificationCountDispatcher);
  }

  getInitialState() {
    return {callbacks: {}}
  }

  reduce(state, action) {
    switch (action.type) {
      case NotificationCountActionTypes.REFRESH_NOTIFICATION_COUNT:
        this.triggerCallbacks('change');
        return state;
      default:
        return state;
    }
  }

  addChangeListener(callbackFunc) {
    if (GlobalSharedTools.isFunction(callbackFunc)) {
      if ('change' in this._state.callbacks) {
        this._state.callbacks['change'].push(callbackFunc);
      } else {
        this._state.callbacks['change'] = [callbackFunc]
      }
    }
  }

  removeChangeListener(callbackFunc) {
    if (GlobalSharedTools.isFunction(callbackFunc) && ('change' in this._state.callbacks)) {
      let index = this._state.callbacks.change.findIndex((handler) => handler === callbackFunc);
      if (index >= 0) {
        this._state.callbacks.change.splice(index, 1);
      }
    }
  }

  triggerCallbacks(sectionName) {
    setTimeout(() => {
      if (this._state.callbacks[sectionName]) {
        this._state.callbacks[sectionName].forEach((functionHandler) => functionHandler.call());
      }
    }, 0);
  }
}

export default new NotificationCountStore();



// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/stores/NotificationCountStore.js